
import React, { Component } from "react";
import { connect } from "react-redux";
import AuthService from "../../services/AuthService";
import * as Actions from "./../../reducers/actions";
import {
  Redirect
} from "react-router-dom";

import BLOCK3 from "../block/block-3";
import BLOCK8 from "../block/block-8";
class Singin extends Component {
  constructor(props) {
    super(props); //info@phoenixy.com phoenixy
    this.state = { username: "", password: "" };
    // this.state = { username: "info@phoenixy.com", password: "phoenixy" };

    this.submit = this.submit.bind(this);
    this.close = this.close.bind(this);
    this.handleUsernameChange = this.handleUsernameChange.bind(this);
    this.handlePasswordChange = this.handlePasswordChange.bind(this);
  }

  handleUsernameChange(event) {
    this.setState({ username: event.target.value });
  }
  handlePasswordChange(event) {
    this.setState({ password: event.target.value });
  }
  submit() {
    let { username, password } = this.state;
      AuthService.login(username, password).then((data)=>{
        console.log('data',data)
        if (!data){
          return ;
        }
        this.props.dispatch(Actions.setToken(data));
        AuthService.getCurrentUser().then((user) => {
          console.log('user', user)
          if (user) {
            let data = user ? user.profile : {};
            this.props.dispatch(Actions.setUser(data));
          } else {
            // this.props.dispatch(Actions.setUser({}));
          }
        });
      });
  }
  close(){
    this.setState({ username: "", password: "" });
    AuthService.logout();
  }
  render() {
    return (
      <div className="App">
        {this.props.token ? <Redirect to="/main" /> : <div />}
        <div id="wrapper">
          <div id="body" style={{ visibility: "visible" }}>
            <table style={{ width: "100%", height: "100%" }}>
              <tbody>
                <tr>
                  <td style={{ width: "200px", verticalAlign: "top" }}>
                    <div id="navigator">
                      <div id="block-2" style={{ padding: "3px 3px 8px 3px" }}>
                        <div
                          id="menu-title"
                          style={{
                            backgroundImage: "url(images/GeenYellowBar.png)",
                            color: "white"
                          }}
                        >
                          เข้าสู่ระบบ
                        </div>
                        <div style={{ height: "110px" }}>
                          <form method="post" action="./xmain.php" name="login">
                            <table id="LoginForm">
                              <tbody>
                                <tr>
                                  <th>อีเมล&nbsp;</th>
                                  <td>
                                    <input
                                      type="text"
                                      name="user"
                                      value={this.state.username}
                                      onChange={this.handleUsernameChange}
                                      placeholder="someone@example.com"
                                      size="25"
                                    />
                                  </td>
                                </tr>
                                <tr>
                                  <th>รหัสผ่าน&nbsp;</th>
                                  <td>
                                    <input
                                      type="password"
                                      name="password"
                                      size="25"
                                      value={this.state.password}
                                      onChange={this.handlePasswordChange}
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                            <div style={{ textAlign: "center" }}>
                              <ul className="myLoginMenu">
                                <li>
                                  <a href="#" onClick={() => this.submit()}>
                                    ตกลง
                                  </a>
                                </li>
                                <li>
                                  <a href="#" onClick={() => this.close()}>
                                    ยกเลิก
                                  </a>
                                </li>
                                <li>
                                  {/* <a href="#">ลืมรหัสผ่าน</a> */}
                                </li>
                              </ul>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </td>
                  <td style={{ verticalAlign: "top" }}>
                    <div id="content">
                      <BLOCK3/>
                      <BLOCK8/>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    );
  }
}
function mapStateToProps(state) {
  return { token: state.default.token, user: state.default.user };
}

export default connect(mapStateToProps)(Singin);
// export default Singin;


// WEBPACK FOOTER //
// ./src/view/singin/singin.js